import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const userMessageCss = css`
  align-items: flex-start;
  display: flex;
  gap: ${m('--spacing-s')};
  justify-content: flex-end;
  padding: ${m('--spacing-m')} 0;
  padding-left: ${m('--spacing-xxxxl')};
  width: 100%;
`;

export const userMessageBubbleCss = css`
  border: ${m('--border-width-xs')} solid ${m('--palette-plain-black')};
  border-radius: ${m('--border-radius-m')};
  color: ${m('--palette-plain-black')};
  flex: 1 0 0;
  font-size: ${m('--p3-mobile-font-size')};
  font-weight: 500;
  line-height: 1.4;
  min-height: 0;
  min-width: 0;
  padding: ${m('--spacing-xs')} ${m('--spacing-m')};
  white-space: pre-wrap;
`;
